<template>
  <div class="cooperation-case-box">
    <div class="show-flex-box-c">
      <dl class="show-flex-box-c">
        <dt class="show-flex-box-c">
          <span>合作案例</span>
          <strong></strong>
        </dt>
        <dd class="choose-answer show-flex-box-c">
          <strong>德阳经开科创全国合作伙伴已超过500家，以专业、创新的服务态度，助您领跑行业前沿。(部分合作案例)</strong>
        </dd>
        <dd class="choose-pic-box show-flex-box-c">
          <dl class="show-flex-box-c">
            <dt class="show-flex-box-r">
              <span v-for="(item,index) in caseList" :key="index">
                <img :src="item.img" alt="德阳经开科创" draggable="false">
              </span>
            </dt>
          </dl>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cooperation_case_cpn',
  data () {
    return {
      caseList: [
        {'img': require('../../assets/home/cooperation_case/cooperation_case_7.png')},
        {'img': require('../../assets/home/cooperation_case/cooperation_case_8.png')},
        {'img': require('../../assets/home/cooperation_case/cooperation_case_10.png')},
        {'img': require('../../assets/home/cooperation_case/cooperation_case_4.png')},
        {'img': require('../../assets/home/cooperation_case/cooperation_case_5.png')},
        {'img': require('../../assets/home/cooperation_case/cooperation_case_6.png')},
        {'img': require('../../assets/home/cooperation_case/cooperation_case_1.png')},
        {'img': require('../../assets/home/cooperation_case/cooperation_case_2.png')},
        {'img': require('../../assets/home/cooperation_case/cooperation_case_9.png')},
        {'img': require('../../assets/home/cooperation_case/cooperation_case_3.png')}
      ]
    }
  }
}
</script>

<style lang="less" scoped>

  //公共字体样式  start
  .coperation-process-font-style( @size; @weight; @height; @color ) {
    display: block;
    font-size: @size;
    font-weight: @weight;
    line-height: @height;
    color: @color;
    word-break: break-all;
  }

  .cooperation-case-box{
    width: 100%;
    background: #FAFAFA;
    &>div{
      margin: 0 auto;
      width: 1200px;
      align-items: center;
      &>dl{
        width: 100%;
        align-items: center;
        &>dt{
          align-items: center;
          &>span{
            word-wrap: none;
            .coperation-process-font-style( 40px; bold; auto; #191D21 );
            padding-top: 82px;
          }
          &>strong{
            display: block;
            width: 130px;
            height: 5px;
            background: #FF7800;
            margin-top: 19px;
            margin-bottom: 40px;
          }
        }
        &>.choose-answer{
          align-items: center;
          padding-bottom: 50px;
          &>strong{
            .coperation-process-font-style( 18px; 400; 34px; #3E3A39 );
          }
        }
        &>.choose-pic-box{
          width: 100%;
          padding-bottom: 63px;
          &>dl{
            width: 100%;
            &>dt{
              width: 100%;
              flex-wrap: wrap;
              justify-content: space-between;
              align-items: center;
              padding-bottom: 18px;
              &>span{
                display: inline-block;
                font-size: 0;
                line-height: 80px;
                text-align: center;
                width: 168px;
                height: 80px;
                padding: 20px 30px 20px 30px;
                border-radius:10px;
                margin-bottom: 10px;
                background: #fff;
                box-shadow:0px 2px 6px 0px rgba(127,127,127,0.25);
                &>img{
                  max-width: 100%;
                  max-height: 100%;
                  vertical-align: middle;
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/cooperation_case_cpn.vue